module.exports = __webpack_public_path__ + "img/sintesis.32e807d7.svg";